import axios from 'axios';

const baseURL = `api/modelselection`;

export default {
    getModelSelectionCharacteristics() {
        const token = localStorage.getItem('token')
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return axios.get(baseURL);
    },
};